import { LitElement } from "lit-element";
import { html } from "lit-html";
import { storeInstance } from "store/index.js";
import { Router } from "@vaadin/router/dist/vaadin-router.js";
import "@vaadin/vaadin-button";
import getProductTreeId from "../utils/getProductTreeId";
import { getConfigVariable, setProductTree } from "../lib/util";
import "@vaadin/vaadin-icons/vaadin-icons.js";
import { unsafeHTML } from "lit-html/directives/unsafe-html.js";
import { cache } from "lit-html/directives/cache.js";

class KbHomepage extends LitElement {
  constructor() {
    super();
    this.numberOfVisibleChildren = 5;
    this.showList = {};
  }

  static get properties() {
    return {
      bannerHtml: { type: String },
      itemLangTree: { type: Object },
      productTreeId: { type: Number },
      numberOfVisibleChildren: { type: Number },
      showList: { type: Object },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.itemLangTree = this.state.item_lang_tree;
    this.fetchBannerHtml();
    storeInstance.dispatch("getLangTree");
    storeInstance.dispatch("getParentPath", { extId: "ROOT" });
    this.productTreeId = getProductTreeId(this.state.panel_control_defs);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.itemLangTree = this.state.item_lang_tree;
    this.productTreeId = getProductTreeId(this.state.panel_control_defs);
  }

  iconTemplate(iconName, type) {
    return html`<span class=${`badge badge-${type}`}></span>
      <iron-icon icon=${`${iconName}`}></iron-icon
    ></span>`;
  }

  publicationIconTemplate(type) {
    console.log(type);
    switch (type) {
      case "filePub":
        return this.iconTemplate("vaadin:file-text", type);
      case "download":
        return this.iconTemplate("vaadin:file-text", type);
      case "helpset":
        return this.iconTemplate("vaadin:file-tree-sub", type);
      case "category":
        return this.iconTemplate("vaadin:folder", type);
    }
  }

  async fetchImage(lblSeqId) {
    const response = await fetch(`/kb/jrest/getResource?lblSeqId=${lblSeqId}`);
    const blob = await response.blob();
    return blob;
  }

  async fetchBannerHtml() {
    let bannerPath = "/Content/KbContent/HomeLine.html";
    const response = await fetch(
      `/kb/jrest/getResource?resPathId=${bannerPath}&langCode=${this.state.langCode}`
    );
    this.bannerHtml = await response.text();
  }

  _gotoItem(item) {
    storeInstance.dispatch("setState", {
      property: "item",
      value: { item: item },
    });
    if (item.type === "category") {
      if (this.productTreeId) {
        setProductTree(this.state?.item?.item?.externalId);
        Router.go(
          `/kb/${this.state.langCode}/pubsearch?${this.productTreeId}=${item.externalId}`
        );
      } else {
        Router.go(`/kb/${this.state.langCode}/pubsearch`);
      }
    } else {
      Router.go("/kb/" + this.state.langCode + "/" + item.externalId);
    }
  }

  _gotoItemFromLink(e, item) {
    e.stopPropagation();
    this._gotoItem(item);
  }

  noItemLangsTemplate() {
    return html`<p class="section-cards">No categories found.</p>`;
  }

  handleViewClick(e, index) {
    e.preventDefault();
    e.stopPropagation();
    let list = this.shadowRoot.querySelector(`#list-${index}`);
    let excessEls = list.querySelectorAll("li:nth-child(n+6)");
    if (this.showList[index]) {
      excessEls.forEach((el) => (el.style.display = "none"));
    } else {
      excessEls.forEach((el) => (el.style.display = "block"));
    }
    this.showList = {
      ...this.showList,
      [index]: !this.showList[index],
    };
  }

  handleImgError(e) {
    e.target.remove();
    this.shadowRoot.querySelector(".overlay").remove();
  }

  // Renders itemlangs added to root
  rootItemLangTemplate(itemLang) {
    return html` <style>
        .root-item-lang {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      </style>
      <div
        class="card__container root-item-lang"
        @click=${() => this._gotoItem(itemLang.item)}
      >
        <p>${itemLang?.itemLang?.name}</p>
      </div>`;
  }

  hasRootTemplate(itemLang, index) {
    if (itemLang.item.type === "category") {
      return this.iconCardTemplate(itemLang, index);
    } else {
      return this.rootItemLangTemplate(itemLang, index);
    }
  }

  bannerTemplate() {
    return html`
      <div class="title__container">
        <!-- <div class="overlay"></div>
        <div class="banner-img"></div> -->
        ${cache(
          this.bannerHtml ? html`${unsafeHTML(this.bannerHtml)}` : "Loading..."
        )}
        <!-- <h1 class="title">${this.string["_homebanner"]}</h1>
        <vaadin-button class="btn" theme="primary" @click=${this.handleClick}
          >Go to publications</vaadin-button
        > -->
      </div>
    `;
  }

  alliedBannerTemplate() {
    return html`
      <style>
        .title__container {
          text-align: center;
        }
      </style>
      <div class="title__container">
        <div class="banner-img"></div>
        <h1 class="title">${this.string["_homebanner"]}</h1>
        <p class="tagline">
          Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean
          commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus
          et magnis dis parturient montes, nascetur rid
        </p>
      </div>
    `;
  }

  viewMoreTemplate(children, index) {
    let hideViewMore = getConfigVariable("hideViewMoreDropdownOnTile");
    if (hideViewMore) return;

    if (children.length > this.numberOfVisibleChildren) {
      if (Boolean(this.showList[index])) {
        return html`<button
          @click=${(e) => this.handleViewClick(e, index)}
          class="view-more-btn"
        >
          Show Less <iron-icon icon="vaadin:angle-up"></iron-icon>
        </button>`;
      } else {
        return html`<button
          @click=${(e) => this.handleViewClick(e, index)}
          class="view-more-btn"
        >
          View More <iron-icon icon="vaadin:angle-down"></iron-icon>
        </button>`;
      }
    }
  }

  cardLayout() {
    switch (homelayout) {
      case "OneLevel":
        return this.oneLayerTemplate();
      default:
        return this.twoLayerTemplate();
    }
  }

  homepageTemplate() {
    return html` ${this.bannerTemplate()} ${this.cardLayout()}`;
  }

  hasImage(itemLang) {
    return itemLang.item.effectiveImageSeqId > 0;
  }

  // Themes

  oneLayerTemplate() {
    return html`
      <style>
        .cards {
          margin-bottom: 2rem;
          color: var(--kb-tile-text);
        }

        .card__container {
          background-color: var(--kb-tile-background);
          padding: 0.25rem 1rem;
          border-radius: 0;
          margin-bottom: 1rem;
          height: 12rem;
          overflow-y: auto;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .card__container:hover {
          background-color: var(--kb-tile-hover-color);
          cursor: pointer;
        }

        .card__title {
          margin-top: 1rem;
          color: var(--kb-tile-header-color);
          font-family: var(--kb-font-heading, var(--kb-font-family-sans));
          margin-bottom: 1rem;
          font-size: 1.25rem;
        }

        .list-container {
          color: var(--kb-tile-body-color);
          scrollbar-gutter: stable both-edges;
        }

        .overlay {
          right: 0;
          inset: 0;
          z-index: 1;
          opacity: 52%;
          position: absolute;
          display: var(--kb-banner-overlay-display);
          background: black;
        }

        @media only screen and (min-width: 480px) {
          .cards {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            column-gap: 1%;
            row-gap: 8px;
          }
        }

        @media only screen and (min-width: 740px) {
          .cards {
            grid-template-columns: repeat(3, 1fr);
            column-gap: 2%;
            row-gap: 8px;
          }
        }

        @media only screen and (min-width: 1080px) {
        }

        @media only screen and (min-width: 1400px) {
          .cards {
            grid-template-columns: repeat(4, 1fr);
            column-gap: 2%;
            row-gap: 8px;
          }
        }
      </style>
      <div class="section-cards">
        <h2 class="section-header">Browse By Category</h2>
        <div class="cards">
          ${this.itemLangTree?.children?.map(
            (itemLang) => html`
              <div
                class="card__container"
                @click=${() => this._gotoItem(itemLang.item)}
              >
                <h3 class="card__title">${itemLang.item.effectiveName}</h3>
              </div>
            `
          )}
        </div>
      </div>
    `;
  }

  cardTemplate(itemLang, index) {
    return html` <div
      class="card__container"
      @click=${() => this._gotoItem(itemLang.item)}
    >
      <div class="card__img-container">
        <div class="card__img-overlay"></div>
        <h3 class="card__title">${itemLang.item.effectiveName}</h3>
        ${itemLang.item.effectiveImageSeqId > 0
          ? html`<img class="card__img" src=${`/kb/jrest/getResource?lblSeqId=${itemLang.item.effectiveImageSeqId}`} loading=lazy></img>`
          : null}
      </div>
      <div class="card__content">
        <ul id=${`list-${index}`} class="list-container">
          ${itemLang.children
            .slice(0, 4)
            .map(
              (child) =>
                html` <li
                  @click=${(e) => this._gotoItemFromLink(e, child.item)}
                >
                  ${child.item.type === "category"
                    ? child.item.effectiveName
                    : child.itemLang.name}
                  ${this.publicationIconTemplate(child.item.type)}
                </li>`
            )}
        </ul>
        ${this.viewMoreTemplate(itemLang.children, index)}
      </div>
    </div>`;
  }

  getListContainerHeight(itemLang) {
    if (this.hasImage(itemLang)) {
      return "15rem";
    } else {
      return `fit-content`;
    }
  }

  // Being used by ACI
  iconCardTemplate(itemLang, index) {
    return html` <style>
        .card__container {
          border-radius: 0;
          text-align: center;
          padding: 1rem 0rem 0;
        }

        .card__img {
          object-fit: contain;
        }

        .card__img-container {
          height: 5rem;
          position: relative;
          display: flex;
          align-items: center;
          padding: 2rem 0 1rem;
        }

        .card__title {
          position: initial;
          color: var(--kb-tile-header-color);
          font-family: var(--kb-font-heading, var(--kb-font-family-sans));
          margin-top: 0;
          margin-left: 0;
          font-size: 1.5rem;
          margin-bottom: 0.5rem;
        }

        .card__content {
          overflow-y: visible;
          height: 17rem;
          padding: 0 0.75rem;
        }

        .card__content--no-image {
          padding: 2rem 1rem 1rem;
          overflow-y: auto;
          min-height: 15rem;
        }

        .list-container {
          height: 11rem;
          color: var(--kb-tile-body-color);
          scrollbar-gutter: stable both-edges;
        }

        .list-container--no-image {
          color: var(--kb-tile-body-color);
          scrollbar-gutter: stable both-edges;
          min-height: 15rem;
          height: fit-content;
          max-height: 28rem;
        }
      </style>
      <div
        class="card__container"
        @click=${() => this._gotoItem(itemLang.item)}
      >
        ${itemLang.item.effectiveImageSeqId > 0
          ? html`
        <div class="card__img-container">
            <img class="card__img" src=${`/kb/jrest/getResource?lblSeqId=${itemLang.item.effectiveImageSeqId}`} loading=lazy></img>
        </div>`
          : null}
        <div
          class=${!this.hasImage(itemLang)
            ? "card__content--no-image"
            : "card__content"}
        >
          <h3 class="card__title">${itemLang.item.effectiveName}</h3>
          <ul
            id=${`list-${index}`}
            class=${!this.hasImage(itemLang)
              ? "list-container--no-image"
              : "list-container"}
          >
            ${itemLang.children.map(
              (child) =>
                html` <li
                  @click=${(e) => this._gotoItemFromLink(e, child.item)}
                >
                  ${child.item.type === "category"
                    ? child.item.effectiveName
                    : child.itemLang.name}
                </li>`
            )}
          </ul>
          ${this.viewMoreTemplate(itemLang.children, index)}
        </div>
      </div>`;
  }

  twoLayerTemplate() {
    return html` <div class="section-cards">
      <div class="cards">
        ${this.itemLangTree?.children?.map((itemLang, index) => {
          return this.hasRootTemplate(itemLang, index);
        })}
      </div>
    </div>`;
  }

  handleClick() {
    Router.go(`/kb/${this.state.langCode}/pubsearch`);
  }

  render() {
    return html` <style>
        .title__container {
          color: white;
          position: relative;
          padding: 1.5rem 1rem;
          margin-bottom: 1.5rem;
          background: var(--kb-banner-background);
          background-size: cover;
        }

        .title {
          font-size: 1.5rem;
          margin-bottom: 1rem;
          z-index: 2;
          position: relative;
          color: var(--kb-banner-title-color);
        }

        .btn {
          position: relative;
          z-index: 1;
          background-color: var(--kb-banner-button-background);
          color: var(--kb-banner-button-text);
        }

        .view-more-btn {
          display: block;
          position: relative;
          z-index: 100;
          opacity: 59%;
          background: none;
          text-align: left;
          padding: 0;
          border: none;
          font-size: 1rem;
          margin: 1rem 0 0 0;
          width: 100%;
        }

        .list-container li:nth-child(n + 6) {
          display: ${getConfigVariable("hideViewMoreDropdownOnTile")
            ? "block"
            : "none"};
        }

        .section-cards {
          margin: 1rem;
        }

        .section-header {
          font-size: 1.25rem;
          margin-bottom: 1.5rem;
          color: #283848;
        }

        iron-icon {
          width: 0.9125rem;
        }

        .cards {
          margin-bottom: 2rem;
          color: var(--kb-tile-text);
        }

        .card__img {
          height: 100%;
          object-fit: cover;
          object-position: center top;
          width: 100%;
        }

        .card__img-container {
          height: 5rem;
          position: relative;
          display: flex;
          align-items: center;
        }

        .card__img-overlay {
          position: absolute;
          z-index: 5;
          background-color: #0000007d;
          width: 100%;
          height: 100%;
        }

        .card__container {
          background-color: var(--kb-tile-background);
          border-radius: 16px;
          margin-bottom: 1rem;
        }

        .card__container:hover {
          background-color: var(--kb-tile-hover-color);
          cursor: pointer;
        }

        .card__content {
          overflow-y: auto;
          height: 17rem;
        }

        .card__title {
          margin-top: 1rem;
          margin-bottom: 1rem;
          color: var(--kb-tile-header-color);
          font-family: var(--kb-font-heading, var(--kb-font-family-sans));
          position: absolute;
          z-index: 10;
          margin-left: 1.25rem;
        }

        .list-container {
          color: var(--kb-tile-body-color);
          scrollbar-gutter: stable both-edges;
        }

        .banner-img {
          background-image: var(--kb-banner-image-url);
          background-repeat: no-repeat;
          position: absolute;
          background-size: cover;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          overflow: hidden;
        }

        li {
          list-style: none;
          margin: var(--kb-tile-list-item-margin, 0 0 1rem 0);
          position: relative;
          z-index: 100;
        }

        li:hover {
          text-decoration: underline;
          cursor: pointer;
        }

        /* width */
        ::-webkit-scrollbar {
          width: 0.5rem;
        }

        /* Track */
        ::-webkit-scrollbar-track {
          box-shadow: inset 0 0 5px var(--kb-primary-color-100);
          border-radius: 20px;
        }

        /* Handle */
        ::-webkit-scrollbar-thumb {
          background: var(--kb-primary-color-400);
          border-radius: 20px;
        }

        ul {
          margin-top: 0.75rem;
          padding: 0;
          overflow-y: auto;
          overflow-wrap: anywhere;
        }

        .overlay {
          right: 0;
          inset: 0;
          z-index: 1;
          opacity: 52%;
          position: absolute;
          background: black;
        }

        @media only screen and (min-width: 480px) {
          .cards {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            column-gap: 1%;
            row-gap: 8px;
          }
        }

        @media only screen and (min-width: 740px) {
          .title__container {
            padding: 1.5rem 3rem;
          }

          .cards {
            grid-template-columns: repeat(3, 1fr);
            column-gap: 2%;
            row-gap: 8px;
          }

          .section-cards {
            margin: 1rem;
          }
        }

        @media only screen and (min-width: 1080px) {
          .title {
            font-size: 1.9rem;
          }

          .section-cards {
            margin: 1rem;
          }

          .title__container {
            padding: 2rem 3rem;
            margin-bottom: 3rem;
          }
        }

        @media only screen and (min-width: 1400px) {
          .title {
            font-size: 1.9rem;
          }

          .title__container {
            margin-bottom: 3rem;
            padding: 4rem 3rem;
          }

          .cards {
            grid-template-columns: repeat(4, 1fr);
            column-gap: 2%;
            row-gap: 8px;
          }

          .section-cards {
            margin: 1rem;
          }
        }
      </style>
      <section>${this.homepageTemplate()}</section>`;
  }
}

customElements.define("kb-homepage", KbHomepage);
